import React, { useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle, Send, Instagram, Phone } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/config";

export default function Contact() {
  const [form, setForm] = useState({ nome: "", email: "", messaggio: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.nome || !form.email || !form.messaggio) {
      toast.error("Compila tutti i campi");
      return;
    }
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Messaggio inviato! Ti risponderemo al più presto.");
      setForm({ nome: "", email: "", messaggio: "" });
    } catch (e) {
      toast.error("Errore invio, riprova.");
    }
    setLoading(false);
  };

  return (
    <section id="contatti" className="relative py-24 md:py-32 px-5 md:px-8" data-testid="contact-section">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          <div>
            <div className="text-xs tracking-[0.4em] uppercase text-fp-cyan font-heading font-semibold">
              Parliamone
            </div>
            <h2 className="mt-4 font-heading font-black text-4xl md:text-5xl lg:text-6xl tracking-tight silver-gradient">
              Hai <span className="cyan-gradient">domande</span>?
            </h2>
            <p className="mt-5 text-white/60 text-base md:text-lg max-w-lg">
              Scrivici per qualsiasi dubbio sull'iscrizione, le regole o i pagamenti. Ti rispondiamo il prima possibile.
            </p>

            <div className="mt-10 space-y-4">
              <a
                href="https://wa.me/393778100717"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 p-4 rounded-2xl border border-white/10 bg-fp-surface/40 hover:border-fp-cyan/50 transition-all group"
                data-testid="whatsapp-contact"
              >
                <div className="w-11 h-11 rounded-xl bg-fp-cyan/10 border border-fp-cyan/30 flex items-center justify-center text-fp-cyan">
                  <MessageCircle size={20} />
                </div>
                <div>
                  <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 font-heading font-semibold">WhatsApp</div>
                  <div className="text-white group-hover:text-fp-cyan transition-colors font-heading font-semibold">+39 377 8100717</div>
                </div>
              </a>
              <div className="flex items-center gap-4 p-4 rounded-2xl border border-white/10 bg-fp-surface/40">
                <div className="w-11 h-11 rounded-xl bg-fp-cyan/10 border border-fp-cyan/30 flex items-center justify-center text-fp-cyan">
                  <Instagram size={20} />
                </div>
                <div>
                  <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 font-heading font-semibold">Social</div>
                  <div className="text-white">@fantapartenope</div>
                </div>
              </div>
            </div>
          </div>

          <motion.form
            onSubmit={submit}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="p-7 md:p-10 rounded-3xl border border-white/10 bg-fp-surface/40 backdrop-blur-sm tracing-border"
            data-testid="contact-form"
          >
            <div className="space-y-5">
              <div>
                <label className="text-[10px] tracking-[0.3em] uppercase text-fp-cyan font-heading font-semibold">Nome</label>
                <input
                  type="text"
                  value={form.nome}
                  onChange={(e) => setForm({ ...form, nome: e.target.value })}
                  className="mt-2 w-full px-4 py-3 rounded-xl bg-fp-bg/60 border border-white/10 focus:border-fp-cyan focus:outline-none text-white placeholder:text-white/30 transition-colors"
                  placeholder="Mario Rossi"
                  data-testid="contact-nome"
                />
              </div>
              <div>
                <label className="text-[10px] tracking-[0.3em] uppercase text-fp-cyan font-heading font-semibold">Email</label>
                <input
                  type="email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className="mt-2 w-full px-4 py-3 rounded-xl bg-fp-bg/60 border border-white/10 focus:border-fp-cyan focus:outline-none text-white placeholder:text-white/30 transition-colors"
                  placeholder="mario@example.com"
                  data-testid="contact-email"
                />
              </div>
              <div>
                <label className="text-[10px] tracking-[0.3em] uppercase text-fp-cyan font-heading font-semibold">Messaggio</label>
                <textarea
                  rows={5}
                  value={form.messaggio}
                  onChange={(e) => setForm({ ...form, messaggio: e.target.value })}
                  className="mt-2 w-full px-4 py-3 rounded-xl bg-fp-bg/60 border border-white/10 focus:border-fp-cyan focus:outline-none text-white placeholder:text-white/30 transition-colors resize-none"
                  placeholder="Scrivi il tuo messaggio..."
                  data-testid="contact-messaggio"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full inline-flex items-center justify-center gap-2 px-6 py-4 rounded-xl bg-fp-cyan text-fp-bg font-heading font-bold tracking-wider uppercase text-sm hover:shadow-[0_0_25px_rgba(0,229,255,0.6)] hover:-translate-y-0.5 transition-all duration-300 disabled:opacity-50"
                data-testid="contact-submit"
              >
                {loading ? "Invio..." : (<>Invia messaggio <Send size={16} /></>)}
              </button>
            </div>
          </motion.form>
        </div>
      </div>
    </section>
  );
}
